module.exports = __webpack_public_path__ + "static/media/event_hashtag_detail_web.f12504a1.webp";